import type { IntlKey } from 'locales';
import { FC, ReactNode, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { IconWorkaround } from './result/status';
import { TileLayout } from './TileLayout';

type ReminderTileLayoutProps = Readonly<{
  children: ReactNode;
  className: string;
  titleKey: IntlKey;
  messageKey: IntlKey;
  icon?: string;
  image?: string;
}>;

export const ReminderTileLayout: FC<ReminderTileLayoutProps> = ({
  titleKey,
  messageKey,
  image,
  icon,
  children,
  className,
}) => {
  const { formatMessage } = useIntl();

  const footer = useMemo(
    () => (
      <div className="card-footer">
        <div className="d-flex justify-content-between">{children}</div>
      </div>
    ),
    [children],
  );
  return (
    <TileLayout footer={footer} className={className}>
      <div className="d-flex px-3 flex-column justify-content-center align-items-center h-100">
        {icon && <i className="icon">{icon}</i>}
        {image && <IconWorkaround missingIconName={image} scaleFactor={2} className="pe-2" />}
        <h4 className="text-center">{formatMessage({ id: titleKey })}</h4>
        <span className="text-large text-start mx-3 mt-4">{formatMessage({ id: messageKey })}</span>
      </div>
    </TileLayout>
  );
};
